import './App.css'
import React, { ReactElement } from 'react'
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import { Layout } from 'antd'

import TopMenu from './component/TopMenu'
import SideMenu from './component/SideMenu'
import UserData from './js/userData'
import icon1 from './images/icon.png'

// 页面路径引用
// 首页
import HeaderUserMenu from './component/HeaderUserMenu'
import Index from './pages/index/Index'
import IndexUserInfo from './pages/index/IndexUserInfo'

// 月子中心
import YueziPackageList from './pages/yueziCentre/YueziPackageList'
import AddEditYueziPackage from './pages/yueziCentre/AddEditYueziPackage'
import StoreYueziPackage from './pages/yueziCentre/StoreYueziPackage'
import YueziOrderList from './pages/yueziCentre/YueziOrderList'

import StoreMarketingActivity from './pages/yueziCentre/StoreMarketingActivity'
import StoreMaterialType from './pages/yueziCentre/StoreMaterialType'
import StoreMaterial from './pages/yueziCentre/StoreMaterial'

// 产康中心
import ChankangItemType from './pages/chankangCentre/ChankangItemType'
import ChankangItemSingleList from './pages/chankangCentre/ChankangItemSingleList'
import AddEditChankangItemSingle from './pages/chankangCentre/components/AddEditChankangItemSingle'
import ChankangItemPackageList from './pages/chankangCentre/ChankangItemPackageList'
import ChankangItemPackageDetail from './pages/chankangCentre/ChankangItemPackageDetail'
import AddEditChankangItemPackage from './pages/chankangCentre/components/AddEditChankangItemPackage'
import StoreChankangItem from './pages/chankangCentre/StoreChankangItem'
import ChankangOrderList from './pages/chankangCentre/ChankangOrderList'
import ChankangOrderDetail from './pages/chankangCentre/ChankangOrderDetail'
import AddChankangOrder from './pages/chankangCentre/components/AddChankangOrder'
import EditChankangOrder from './pages/chankangCentre/components/EditChankangOrder'

import ChankangCustomerList from './pages/chankangCentre/ChankangCustomerList'
import ChankangCustomerDetail from './pages/chankangCentre/ChankangCustomerDetail'
import AddChankangCustomerOrder from './pages/chankangCentre/components/AddChankangCustomerOrder'
import ChankangConsumeList from './pages/chankangCentre/ChankangConsumeList'

import ChankangRecoverList from './pages/chankangCentre/ChankangRecoverList'
import ChankangRecoverDetail from './pages/chankangCentre/ChankangRecoverDetail'

import MonthReportList from './pages/chankangCentre/MonthReportList'

// 营销中心
import CustomerAllList from './pages/marketingCentre/CustomerAllList'
import CustomerOnlineList from './pages/marketingCentre/CustomerOnlineList'
import CustomerMedicalList from './pages/marketingCentre/CustomerMedicalList'
import CustomerVisitList from './pages/marketingCentre/CustomerVisitList'

import SalesList from './pages/marketingCentre/SalesList'
import EditSales from './pages/marketingCentre/components/EditSales'
import SalesScheduling from './pages/marketingCentre/SchedulingSales'
import AddSalesScheduling from './pages/marketingCentre/components/AddSchedulingSales'

import KefuScheduling from './pages/marketingCentre/SchedulingKefu'
import AddKefuScheduling from './pages/marketingCentre/components/AddSchedulingKefu'

import ConfigNoEffectiveReasonList from './pages/marketingCentre/ConfigNoEffectiveReasonList'
import ConfigFollowLevelList from './pages/marketingCentre/ConfigFollowLevelList'

import ReportStoreResults from './pages/marketingCentre/ReportStoreResultsList'
import ReportStoreConverRate from './pages/marketingCentre/ReportStoreConverRateList'
import ReportSalesResults from './pages/marketingCentre/ReportSalesResultsList'
import ReportSalesConverRate from './pages/marketingCentre/ReportSalesConverRateList'

// 财务中心
import YueziPayMoney from '././pages/financeCentre/YueziPayMoney'
import YueziContractChange from './pages/financeCentre/YueziContractChange'
import YueziRefundMoney from './pages/financeCentre/YueziRefundMoney'
import YuesaoPayMoney from './pages/financeCentre/YuesaoPayMoney'
import YuesaoRefundMoney from './pages/financeCentre/YuesaoRefundMoney'
import ChankangPayMoney from './pages/financeCentre/ChankangPayMoney'
import ChankangPayItem from './pages/financeCentre/ChankangPayItem'
import ChankangRefundMoney from './pages/financeCentre/ChankangRefundMoney'

import ReportDayData from './pages/financeCentre/ReportDayData'
import ReportMonthData from './pages/financeCentre/ReportMonthData'
import ReportPromoter from './pages/financeCentre/ReportPromoter'
import ReportPromoterDeal from './pages/financeCentre/ReportPromoterDeal'

import ReportCheckIn from './pages/financeCentre/ReportCheckIn'
import ReportCheckInIncome from './pages/financeCentre/ReportCheckInIncome'
import ReportCheckInIncomeDetail from './pages/financeCentre/ReportCheckInIncomeDetail'
import ReportChanKang from './pages/financeCentre/ReportChanKang'

// 管家中心
import CheckInList from './pages/keeperCentre/CheckInList'
import CheckInDetail from './pages/keeperCentre/CheckInDetail'
import RoomStatus from './pages/keeperCentre/RoomStatus'
import StoreRoomStatus from './pages/keeperCentre/StoreRoomStatus'
import CustomerComplaints from './pages/keeperCentre/CustomerComplaints'
import StoreAcross from './pages/keeperCentre/StoreAcross'
import CustomerContinue from './pages/keeperCentre/CustomerContinue'

import StoreRoom from './pages/keeperCentre/StoreRoom'
import RoomType from './pages/keeperCentre/RoomType'

import CustomerInfoScan from './pages/keeperCentre/CustomerInfoScan'
import CustomerQuestionList from './pages/keeperCentre/CustomerQuestionList'
import MonthCheckInReport from './pages/keeperCentre/MonthCheckInReport'
import MonthCheckInSummary from './pages/keeperCentre/MonthCheckInSummary'

// 膳食中心
import CookingCustomer from './pages/cookingCentre/CookingCustomer'
import CookingCustomerDetail from './pages/cookingCentre/CookingCustomerDetail'
import CookingCustomerDiningDetail from './pages/cookingCentre/CookingCustomerDiningDetail'
import CookingCustomerTodayDining from './pages/cookingCentre/CookingCustomerTodayDining'
import MenuTemplate from './pages/cookingCentre/MenuTemplate'
import AddEditMenuTemplate from './pages/cookingCentre/AddEditMenuTemplate'

import FoodType from './pages/cookingCentre/FoodType'
import FoodItem from './pages/cookingCentre/FoodItem'
import MenuStyle from './pages/cookingCentre/MenuStyle'
import MenuType from './pages/cookingCentre/MenuType'
import MenuItem from './pages/cookingCentre/MenuItem'

import DiningOrder from './pages/cookingCentre/DiningOrder'
import DiningOrderDetail from './pages/cookingCentre/DiningOrderDetail'


import FoodPurchaseEdit from './pages/cookingCentre/DiningOrder'
import TodayMealOrder from './pages/cookingCentre/TodayMealOrder'
import HistoryMealOrder from './pages/cookingCentre/HistoryMealOrder'
import CaiGouList from './pages/cookingCentre/CaiGouList'
import CaiGouSQ from './pages/cookingCentre/CaiGouSQ'
import CaiGouSQDetail from './pages/cookingCentre/CaiGouSQDetail'
import SetPriceManage from './pages/cookingCentre/SetPriceManage'
import SetPrice from './pages/cookingCentre/setPrice'
import FoodPurchaseList from './pages/cookingCentre/FoodPurchaseList'
import FoodPurchaseDetail from './pages/cookingCentre/FoodPurchaseDetail'
import FoodDailMealEdit from './pages/cookingCentre/FoodDailMealEdit'


// 护理中心
import NursingCheckInMange from './pages/nursingCentre/NursingCheckInMange'
import NursingCheckInDetail from './pages/nursingCentre/Detail'
import ProjectNursingList from './pages/nursingCentre/ProjectNursingList'
import NursingList from './pages/nursingCentre/NursingList'

// 月嫂中心
import YuesaoClubhouseManage from './pages/yuesaoCentre/ClubhouseCustomerList'
import YuesaoClubhouseDetail from './pages/yuesaoCentre/ClubhouseCustomerDetail'
import YuesaoResidenceManage from './pages/yuesaoCentre/ResidenceCustomerList'
import YuesaoResidenceDetail from './pages/yuesaoCentre/ResidenceCustomerDetail'
import YuesaoCustomerWorkList from './pages/yuesaoCentre/CustomerWorkList'

import YuesaoArchivesManage from './pages/yuesaoCentre/YuesaoArchivesList'
import AddEditYuesaoArchives from './pages/yuesaoCentre/AddEditYuesaoArchives'
import YuesaoScheduleManage from './pages/yuesaoCentre/YuesaoSchedule'
import YuesaoSalaryActualManage from './pages/yuesaoCentre/YuesaoSalaryActualList'
import YuesaoPromotionManage from './pages/yuesaoCentre/YuesaoPromotionList'
import YuesaoPerformanceManage from './pages/yuesaoCentre/YuesaoPerformanceList'
import YuesaoPerformanceDetail from './pages/yuesaoCentre/YuesaoPerformanceDetail'
import YuesaoPerformanceInfoManage from './pages/yuesaoCentre/YuesaoPerformanceInfoList'

import YuesaoCoperationManage from './pages/yuesaoCentre/YuesaoCoperationList'
import AddEditYuesaoCoperation from './pages/yuesaoCentre/AddEditYuesaoCoperation'
import YuesaoStarLevelManage from './pages/yuesaoCentre/YuesaoStarLevelList'
import YuesaoSalaryStandardManage from './pages/yuesaoCentre/YuesaoSalaryStandardList'

// 人力中心
import EmployeeList from './pages/manpowerCentre/EmployeeList'
import AddEditEmployee from './pages/manpowerCentre/AddEditEmployee'
import RoleList from './pages/manpowerCentre/RoleList'
import AddEditRole from './pages/manpowerCentre/AddEditRole'

import DepartmentList from './pages/manpowerCentre/DepartmentList'
import PositionList from './pages/manpowerCentre/PositionList'
import AddEditPosition from './pages/manpowerCentre/AddEditPosition'

// 管理中心
import BrandList from './pages/manageCentre/BrandList'
import AddEditBrand from './pages/manageCentre/AddEditBrand'
import StoreList from './pages/manageCentre/StoreList'
import AddEditStore from './pages/manageCentre/AddEditStore'
import HealthRemindList from './pages/manageCentre/HealthRemindList'
import AddEditHealthRemind from './pages/manageCentre/AddEditHealthRemind'
import ArticleTypeList from './pages/manageCentre/ArticleTypeList'
import ArticleList from './pages/manageCentre/ArticleList'
import AddEditArticle from './pages/manageCentre/AddEditArticle'
import ProjectTagList from './pages/manageCentre/ProjectTagList'

function NoMatch() {
  return <div className="common-page">404...没有相关页面...</div>
}

const { Header, Content } = Layout

type AppState = {
  topIndex: string,
  topNavData: any[],
  sideSelectedKeys: string,
  sideOpenKeys: string,

  sideMenuData: {
    belongIndex: number,
    key: string,
    title: string,
    icon: ReactElement,
    items: {
      key: string,
      title: string,
      url?: string
    }[]
  }[]
}

class App extends React.Component {

  state: AppState = {
    topIndex: '',
    sideOpenKeys: '',
    sideSelectedKeys: '',
    topNavData: [],
    sideMenuData: []
  }

  handleTopNavClick({ key }: { key: string }) {
    for (let i = 0; i < this.state.sideMenuData.length; i++) {
      let o: any = this.state.sideMenuData[i]

      if (o.p_id === this.state.topNavData[Number(key)].id) {
        this.syncMenuKey(o.children[0].route_url)
        break
      }
    }

    this.setState({ topIndex: key })
  }

  handleSideMenuClick({ key }: { key: string }) {
    this.setState({ sideSelectedKeys: key })
  }

  handleSideSubMenuClick({ key }: { key: string }) {
    this.state.sideOpenKeys === key ? this.setState({ sideOpenKeys: '' }) : this.setState({ sideOpenKeys: key })
  }

  syncMenuKey(url: string) {
    let current: { key: string, childKey: string } = { key: '', childKey: '' }

    this.state.sideMenuData.forEach((el: any) => {
      el.children.forEach((el2: any) => {
        if (el2.route_url === url) {
          current.key = el2.p_id
          current.childKey = el2.id
        }
      })
    })

    window.localStorage.setItem('url_id', current.childKey)

    this.setState({
      sideOpenKeys: current.key,
      sideSelectedKeys: current.childKey
    })
  }

  setSideHeight() {
    let aside = document.querySelectorAll('aside')[0] as HTMLElement
    let header = document.querySelectorAll('header')[0] as HTMLElement
    let info = document.querySelectorAll('.info')[0] as HTMLElement

    aside.style.minHeight = window.innerHeight - header.offsetHeight - info.offsetHeight + 'px'
  }

  // 修复顶层菜单对应左边导航第一个页面的权限问题
  fixTopLevelAuth(topArr: any[]): any[] {
    let newTopMenuArr: any[] = []
    function getFirstPageRouteUrl(pid: string): string {
      let url = ''

      if (UserData.left_menu_list.find((el: any) => el.p_id === pid) && UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'] && UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'][0] && UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'][0].route_url) {
        url = UserData.left_menu_list.find((el: any) => el.p_id === pid)['children'][0].route_url
      }

      return url || ''
    }

    topArr.forEach(el => {
      el.route_url = getFirstPageRouteUrl(el.id)
      newTopMenuArr.push(el)
    })

    return newTopMenuArr
  }

  setMenuData() {
    let pathName = window.location.pathname,
      tIndex = ''

    UserData.left_menu_list.forEach((el: any, index: number) => {
      el.children.forEach((el2: any) => {
        if (el2.route_url === pathName) {

          UserData.top_menu_list.forEach((el3: any, index3: number) => {
            if (el3.id === el.p_id) tIndex = index3.toString()
          })
        }
      })
    })

    this.setState({
      topIndex: tIndex.toString(),
      topNavData: this.fixTopLevelAuth(UserData.top_menu_list),
      sideMenuData: UserData.left_menu_list

    }, () => {
      this.syncMenuKey(pathName)
    })
  }

  init() {
    this.setSideHeight()
    this.setMenuData()

    window.addEventListener('resize', (e) => {
      this.setSideHeight()
    })
  }

  componentDidMount() {
    this.init()
  }

  render(): ReactElement {
    return (
      <div className="app">
        <Router>
          <Layout>
            <div className="info clear" id="info">
              <div className="logo clear fl" >
                <h1><img src={icon1} alt="logo" />兴宝月禧业务中台</h1>
              </div>

              <div className="fr">
                <HeaderUserMenu />
              </div>
            </div>

            <Header className="header">
              <div className="shadow"></div>
              <TopMenu
                topIndex={this.state.topIndex}
                topNavData={this.state.topNavData}
                handleTopNavClick={({ key }: { key: string }) => {
                  this.handleTopNavClick({ key })
                }}
              />
            </Header>

            <Layout>
              <SideMenu
                handleSideSubMenuClick={({ key }: { key: string }) => { this.handleSideSubMenuClick({ key }) }}
                handleSideMenuClick={({ key }: { key: string }) => { this.handleSideMenuClick({ key }) }}
                topIndex={this.state.topIndex}
                sideMenuData={this.state.sideMenuData}
                topMenuData={this.state.topNavData}
                sideOpenKeys={this.state.sideOpenKeys}
                sideSelectedKeys={this.state.sideSelectedKeys} />

              <Layout style={{ padding: '0 24px 24px' }}>
                <Content className="site-layout-background" style={{ padding: 24, margin: 0, minHeight: 280 }} >
                  <Switch>

                    {/* ******************** 首页 start ******************** */}

                    {/* 首页 */}
                    <Route path="/" exact>
                      <Index dd={(val: any) => {
                        console.log('进入首页', val)
                      }} />
                    </Route>

                    <Route path="/user_info">
                      <IndexUserInfo />
                    </Route>

                    {/* ******************** 首页 end ******************** */}

                    {/* ******************** 月子中心 start ******************** */}

                    {/* 月子项目管理 */}
                    <Route path="/yuezi_package_list">
                      <YueziPackageList />
                    </Route>
                    <Route path="/yuezi_package_add">
                      <AddEditYueziPackage />
                    </Route>
                    <Route path="/yuezi_package_edit/:id">
                      <AddEditYueziPackage />
                    </Route>
                    <Route path="/store_yuezi_item_list">
                      <StoreYueziPackage />
                    </Route>
                    <Route path="/yuezi_item_order_list">
                      <YueziOrderList />
                    </Route>

                    {/* 月子配置管理 */}
                    <Route path="/store_marketing_activity">
                      <StoreMarketingActivity />
                    </Route>
                    <Route path="/store_material_type">
                      <StoreMaterialType />
                    </Route>
                    <Route path="/store_material">
                      <StoreMaterial />
                    </Route>

                    {/* ******************** 月子中心 end ******************** */}

                    {/* ******************** 产康中心 start ******************** */}

                    {/* 产康项目管理 */}
                    <Route path="/ck_project_type">
                      <ChankangItemType />
                    </Route>

                    <Route path="/ck_single_list">
                      <ChankangItemSingleList />
                    </Route>
                    <Route path="/ck_single_list_add">
                      <AddEditChankangItemSingle />
                    </Route>
                    <Route path="/ck_single_list_edit/:id">
                      <AddEditChankangItemSingle />
                    </Route>

                    <Route path="/ck_set_meal_list">
                      <ChankangItemPackageList />
                    </Route>
                    <Route path="/ck_set_meal_list_detail/:id">
                      <ChankangItemPackageDetail />
                    </Route>
                    <Route path="/ck_set_meal_list_add">
                      <AddEditChankangItemPackage />
                    </Route>
                    <Route path="/ck_set_meal_list_edit/:id">
                      <AddEditChankangItemPackage />
                    </Route>

                    <Route path="/ck_set_up_product">
                      <StoreChankangItem />
                    </Route>

                    <Route path="/ck_order_list">
                      <ChankangOrderList />
                    </Route>
                    <Route path="/ck_order_detail/:id/:type">
                      <ChankangOrderDetail />
                    </Route>
                    <Route path="/ck_order_list_add">
                      <AddChankangOrder />
                    </Route>
                    <Route path="/ck_order_list_update/:id">
                      <EditChankangOrder />
                    </Route>

                    {/* 产康客户管理 */}
                    <Route path="/ck_customer_list">
                      <ChankangCustomerList />
                    </Route>
                    <Route path="/ck_customer_detail/:id">
                      <ChankangCustomerDetail />
                    </Route>
                    <Route path="/ck_customer_order/:id">
                      <AddChankangCustomerOrder />
                    </Route>

                    <Route path="/ck_consume_list">
                      <ChankangConsumeList />
                    </Route>

                    {/* 产康员工管理 */}
                    <Route path="/fix_master_list">
                      <ChankangRecoverList />
                    </Route>
                    <Route path="/set_ck_fix_master/:id">
                      <ChankangRecoverDetail />
                    </Route>

                    {/* 产康数据报表 */}
                    <Route path="/ck_month_report">
                      <MonthReportList />
                    </Route>

                    {/* ******************** 产康中心 end ******************** */}

                    {/* ******************** 营销中心 start ******************** */}

                    {/* 客资管理 */}
                    <Route path="/my_all_customer">
                      <CustomerAllList />
                    </Route>
                    <Route path="/inline_clue">
                      <CustomerOnlineList />
                    </Route>
                    <Route path="/medical_clue">
                      <CustomerMedicalList />
                    </Route>
                    <Route path="/visit_customer">
                      <CustomerVisitList />
                    </Route>

                    {/* 销售管理 */}
                    <Route path="/salesman_mange">
                      <SalesList />
                    </Route>
                    <Route path="/sales_edit/:id">
                      <EditSales />
                    </Route>
                    <Route path="/salesman_scheduling">
                      <SalesScheduling />
                    </Route>
                    <Route path="/salesman_scheduling_add">
                      <AddSalesScheduling />
                    </Route>

                    {/* 客服管理 */}
                    <Route path="/service_scheduling">
                      <KefuScheduling />
                    </Route>
                    <Route path="/customer_scheduling_add">
                      <AddKefuScheduling />
                    </Route>

                    {/* 营销配置 */}
                    <Route path="/marketing_failure">
                      <ConfigNoEffectiveReasonList />
                    </Route>
                    <Route path="/follow_up_grade">
                      <ConfigFollowLevelList />
                    </Route>

                    {/* 营销报表 */}
                    <Route path="/store_results_list">
                      <ReportStoreResults />
                    </Route>
                    <Route path="/store_conver_rate_list">
                      <ReportStoreConverRate />
                    </Route>

                    <Route path="/sales_results_list">
                      <ReportSalesResults />
                    </Route>
                    <Route path="/sales_conver_rate_list">
                      <ReportSalesConverRate />
                    </Route>

                    {/* ******************** 营销中心 end ******************** */}

                    {/* ******************** 财务中心 start ******************** */}

                    {/* 财务管理 */}
                    <Route path="/collection_money">
                      <YueziPayMoney />
                    </Route>
                    <Route path="/contract_change">
                      <YueziContractChange />
                    </Route>
                    <Route path="/refund_money">
                      <YueziRefundMoney />
                    </Route>

                    <Route path="/ys_pay_list">
                      <YuesaoPayMoney />
                    </Route>
                    <Route path="/ys_refund_list">
                      <YuesaoRefundMoney />
                    </Route>

                    <Route path="/ck_collection_ist">
                      <ChankangPayMoney />
                    </Route>
                    <Route path="/ck_pay_item_ist">
                      <ChankangPayItem />
                    </Route>
                    <Route path="/ck_refund_money_ist">
                      <ChankangRefundMoney />
                    </Route>

                    {/* 经营管理 */}
                    <Route path="/finance_day_data">
                      <ReportDayData />
                    </Route>
                    <Route path="/finance_month_data">
                      <ReportMonthData />
                    </Route>
                    <Route path="/finance_promoter">
                      <ReportPromoter />
                    </Route>
                    <Route path="/finance_promoter_deal">
                      <ReportPromoterDeal />
                    </Route>

                    {/* 经营报表 */}
                    <Route path="/report_check_in">
                      <ReportCheckIn />
                    </Route>
                    <Route path="/report_check_in_income">
                      <ReportCheckInIncome />
                    </Route>
                    <Route path="/check_in_income_detail/:id" component={ReportCheckInIncomeDetail}>
                    </Route>
                    <Route path="/report_chan_kang">
                      <ReportChanKang />
                    </Route>

                    {/* ******************** 财务中心 end ******************** */}

                    {/* ******************** 管家中心 start ******************** */}

                    {/* 入住管理 */}
                    <Route path="/check_in_manage">
                      <CheckInList />
                    </Route>
                    <Route path="/check_in_detail/:id">
                      <CheckInDetail />
                    </Route>
                    <Route path="/room_status">
                      <RoomStatus />
                    </Route>
                    <Route path="/room_status2">
                      <StoreRoomStatus />
                    </Route>
                    <Route path="/customer_complaints">
                      <CustomerComplaints />
                    </Route>
                    <Route path="/change_store_room">
                      <StoreAcross />
                    </Route>
                    <Route path="/customer_continue">
                      <CustomerContinue />
                    </Route>

                    {/* 客房配置 */}
                    <Route path="/store_room">
                      <StoreRoom />
                    </Route>
                    <Route path="/room_type">
                      <RoomType />
                    </Route>

                    {/* 数据报表 */}
                    <Route path="/client_excel">
                      <CustomerInfoScan />
                    </Route>
                    <Route path="/customer_question_list">
                      <CustomerQuestionList />
                    </Route>
                    <Route path="/month_in_excel">
                      <MonthCheckInReport />
                    </Route>
                    <Route path="/room_ocsummary">
                      <MonthCheckInSummary />
                    </Route>

                    {/* ******************** 管家中心 end ******************** */}

                    {/* ******************** 膳食中心 start ******************** */}

                    {/* 营养膳食 */}
                    <Route path="/cooking_customer">
                      <CookingCustomer />
                    </Route>
                    <Route path="/cooking_customer_detail/:check_in_id">
                      <CookingCustomerDetail />
                    </Route>
                    <Route path="/cooking_customer_dining_detail/:check_in_id">
                      <CookingCustomerDiningDetail />
                    </Route>
                    <Route path="/cooking_customer_today_dining/:check_in_id">
                      <CookingCustomerTodayDining />
                    </Route>
                    <Route path="/menu_template">
                      <MenuTemplate />
                    </Route>
                    <Route path="/menu_template_add">
                      <AddEditMenuTemplate />
                    </Route>
                    <Route path="/menu_template_edit/:id">
                      <AddEditMenuTemplate />
                    </Route>

                    {/* 菜品管理 */}
                    <Route path="/food_type">
                      <FoodType />
                    </Route>
                    <Route path="/food_item">
                      <FoodItem />
                    </Route>
                    <Route path="/menu_style">
                      <MenuStyle />
                    </Route>
                    <Route path="/menu_type">
                      <MenuType />
                    </Route>
                    <Route path="/menu_item">
                      <MenuItem />
                    </Route>

                    {/* 厨房管理 */}
                    <Route path="/dining_order">
                      <DiningOrder />
                    </Route>
                    <Route path="/dining_order_detail">
                      <DiningOrderDetail />
                    </Route>




                    <Route path="/today_meal_orders">
                      <TodayMealOrder />
                    </Route>
                    <Route path="/history_meal_orders">
                      <HistoryMealOrder />
                    </Route>
                    <Route path="/caigou_list">
                      <CaiGouList />
                    </Route>
                    <Route path="/caigou_sq">
                      <CaiGouSQ />
                    </Route>
                    <Route path="/caigou_sq_detail/:id">
                      <CaiGouSQDetail />
                    </Route>
                    <Route path="/set_price_manage">
                      <SetPriceManage />
                    </Route>
                    <Route path="/set_price">
                      <SetPrice />
                    </Route>
                    <Route path="/food_purchase_list">
                      <FoodPurchaseList />
                    </Route>
                    <Route path="/food_purchase_detail">
                      <FoodPurchaseDetail />
                    </Route>
                    <Route path="/food_purchase_edit">
                      <FoodPurchaseEdit />
                    </Route>
                    <Route path="/food_dail_edit">
                      <FoodDailMealEdit />
                    </Route>


                    {/* ******************** 膳食中心 end ******************** */}

                    {/* ******************** 护理中心 start ******************** */}

                    {/* 护理管理 */}
                    <Route path="/nursing_check_in_mange_list">
                      <NursingCheckInMange />
                    </Route>
                    <Route path="/nursing_check_in_detail/:id">
                      <NursingCheckInDetail />
                    </Route>
                    <Route path="/nursing_project_list">
                      <ProjectNursingList />
                    </Route>
                    <Route path="/nursing_list">
                      <NursingList />
                    </Route>

                    {/* ******************** 护理中心 end ******************** */}

                    {/* ******************** 月嫂中心 start ******************** */}

                    {/* 客户管理 */}
                    <Route path="/yuesao_clubhouse_manage">
                      <YuesaoClubhouseManage />
                    </Route>
                    <Route path="/yuesao_clubhouse_detail/:id">
                      <YuesaoClubhouseDetail />
                    </Route>
                    <Route path="/yuesao_residence_manage">
                      <YuesaoResidenceManage />
                    </Route>
                    <Route path="/yuesao_residence_detail/:id">
                      <YuesaoResidenceDetail />
                    </Route>
                    <Route path="/yuesao_customer_work">
                      <YuesaoCustomerWorkList />
                    </Route>

                    {/* 月嫂管理 */}
                    <Route path="/yuesao_archives">
                      <YuesaoArchivesManage />
                    </Route>
                    <Route path="/yuesao_archives_add">
                      <AddEditYuesaoArchives />
                    </Route>
                    <Route path="/yuesao_archives_edit/:id">
                      <AddEditYuesaoArchives />
                    </Route>
                    <Route path="/yuesao_schedule">
                      <YuesaoScheduleManage />
                    </Route>
                    <Route path="/yuesao_salary_actual">
                      <YuesaoSalaryActualManage />
                    </Route>
                    <Route path="/yuesao_promotion">
                      <YuesaoPromotionManage />
                    </Route>
                    <Route path="/yuesao_performance">
                      <YuesaoPerformanceManage />
                    </Route>
                    <Route path="/yuesao_performance_detail/:id" component={YuesaoPerformanceDetail}></Route>
                    <Route path="/yuesao_performance_info">
                      <YuesaoPerformanceInfoManage />
                    </Route>

                    {/* 月嫂配置 */}
                    <Route path="/yuesao_coperation">
                      <YuesaoCoperationManage />
                    </Route>
                    <Route path="/yuesao_coperation_add">
                      <AddEditYuesaoCoperation />
                    </Route>
                    <Route path="/yuesao_coperation_edit/:id">
                      <AddEditYuesaoCoperation />
                    </Route>
                    <Route path="/yuesao_star_level">
                      <YuesaoStarLevelManage />
                    </Route>
                    <Route path="/yuesao_salary_standard">
                      <YuesaoSalaryStandardManage />
                    </Route>

                    {/* ******************** 月嫂中心 end ******************** */}

                    {/* ******************** 人力中心 start ******************** */}

                    {/* 人员管理 */}
                    <Route path="/personnel_manage">
                      <EmployeeList />
                    </Route>
                    <Route path="/personnel_manage_add">
                      <AddEditEmployee />
                    </Route>
                    <Route path="/personnel_manage_edit/:id">
                      <AddEditEmployee />
                    </Route>

                    <Route path="/role_manage">
                      <RoleList />
                    </Route>
                    <Route path="/role_add">
                      <AddEditRole />
                    </Route>
                    <Route path="/role_edit/:id">
                      <AddEditRole />
                    </Route>

                    {/* 组织管理 */}
                    <Route path="/department">
                      <DepartmentList />
                    </Route>

                    <Route path="/positions">
                      <PositionList />
                    </Route>
                    <Route path="/positions_add">
                      <AddEditPosition />
                    </Route>
                    <Route path="/positions_edit/:id">
                      <AddEditPosition />
                    </Route>

                    {/* ******************** 人力中心 end ******************** */}

                    {/* ******************** 管理中心 start ******************** */}

                    {/* 品牌及门店 */}
                    <Route path="/brand_mange">
                      <BrandList />
                    </Route>
                    <Route path="/brand_add" >
                      <AddEditBrand />
                    </Route>
                    <Route path="/brand_edit/:id">
                      <AddEditBrand />
                    </Route>

                    <Route path="/store_mange">
                      <StoreList />
                    </Route>
                    <Route path="/store_add">
                      <AddEditStore />
                    </Route>
                    <Route path="/store_edit/:id">
                      <AddEditStore />
                    </Route>

                    {/* 妈妈状态管理 */}
                    <Route path="/health_remind_list">
                      <HealthRemindList />
                    </Route>
                    <Route path="/health_remind_add">
                      <AddEditHealthRemind />
                    </Route>
                    <Route path="/health_remind_edit/:id">
                      <AddEditHealthRemind />
                    </Route>

                    {/* 文章管理 */}
                    <Route path="/article_type">
                      <ArticleTypeList />
                    </Route>
                    <Route path="/article_list">
                      <ArticleList />
                    </Route>
                    <Route path="/article_add">
                      <AddEditArticle />
                    </Route>
                    <Route path="/article_edit/:id">
                      <AddEditArticle />
                    </Route>

                    {/* 标签管理 */}
                    <Route path="/project_tag_list">
                      <ProjectTagList />
                    </Route>

                    {/* ******************** 管理中心 end ******************** */}

                    <Route path="*">
                      <NoMatch />
                    </Route>

                  </Switch>
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </Router>
      </div>
    )
  }
}

export default App